import { render, staticRenderFns } from "./transfer-pending-status.vue?vue&type=template&id=003f7cdc&"
import script from "./transfer-pending-status.vue?vue&type=script&lang=js&"
export * from "./transfer-pending-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports